/**
 * ═══════════════════════════════════════════════════════════════════════════════════════
 *  ╔═○─┐ emotive
 *    ●●  ENGINE - Step Left Gesture
 *  └─○═╝
 * ═══════════════════════════════════════════════════════════════════════════════════════
 *
 * Quick weight shift to the left (1 beat)
 */

import { createStepGesture } from './danceSteps.js';

export default createStepGesture('left');
